/**
 * @Description:项目执行人数统计
 * @Date: 2024-01-18 16:31:01
 * **/
const views = (require as any).context('./', true, /pc-module-survey-\d+\.vue/);
export default views.keys().map(path => {
  return views(path).default;
});
